import { SentryService, type SentryEnvironment } from '@travelata-libs/utils';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import Cookies from 'js-cookie';

const AB_TEST_TAG_PREFIX = 'ab.';

declare const SENTRY_DSN: string;
declare const SENTRY_ENVIRONMENT: SentryEnvironment;
declare const SENTRY_RELEASE: string;

const sentryService = new SentryService({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    userId: Cookies.get('clientUuid'),
    tracesSampleRate: 0.001, 
    withReplay: true,
    maskAllInputs: false,
    maskAllText: false,
    blockAllMedia: true,
});

const abTestTags = (getABTestValue() ?? []).reduce((acc, { slug, version }) => {
    acc = {
        ...acc,
        [`${AB_TEST_TAG_PREFIX}${slug}`]: version,
    }
    return acc;
}, {});
sentryService.setTags(abTestTags);

export default sentryService;
